export default __webpack_public_path__ + "static/media/goodreads2.b99c0f4d.png";